export default function getPaymentLogo(payment) {
  try {
    return require(`assets/images/payment/${payment.toLowerCase()}.png`);
  } catch (error) {
    console.log("Can't find payment image for payment platform: ", payment);
    return null;
  }
}
